(function () {
    var video = document.querySelector('[data-hero-video]');
    if (!video) return;

    function startVideo() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var source = video.querySelector('source[data-src]');
        if (!source) return;

        video.addEventListener('playing', function () {
            video.classList.add('is-playing');
        }, { once: true });

        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();

        var playback = video.play();
        if (playback && typeof playback.catch === 'function') {
            playback.catch(function () {});
        }
    }

    if (document.readyState === 'complete') {
        startVideo();
    } else {
        window.addEventListener('load', startVideo, { once: true });
    }
})();
